import styled from "styled-components";
import { borderRadius, spacing } from "@magicbi/ui-library";

export const CreateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing[2]};
  height: ${spacing[10]};
  /* Design margin 10 0 6. */
  margin: ${spacing[2.5]} 0 ${spacing[1.5]};
  border: 0;
  border-radius: ${borderRadius.full};
  cursor: pointer;
  background: ${({ theme }) => theme.colors.primary[500]};
  color: ${({ theme }) => theme.colors.text.inverse};
  /* GAP: design 13px/600; no 13px type token. */
  font-size: 0.8125rem;
  font-weight: 600;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary[500]};
    outline-offset: 2px;
  }
`;

export const Account = styled.div`
  /* Design: margin-top 6, padding 10 8 0. */
  margin-top: ${spacing[1.5]};
  padding: ${spacing[2.5]} ${spacing[2]} 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.stroke};
`;
